import { render } from "./PersonalSignature.vue?vue&type=template&id=336dc26a&scoped=true"
import script from "./PersonalSignature.vue?vue&type=script&lang=js"
export * from "./PersonalSignature.vue?vue&type=script&lang=js"

import "./PersonalSignature.vue?vue&type=style&index=0&id=336dc26a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336dc26a"]])

export default __exports__